<template>
  <div class="text-gray-dark bg-white text-left flex w-full cursor-pointer border-none w-max">
    <checkbox :is-checked.sync="checkboxValue" :id="data.id" :is-wrapped="true">
      <div class="flex">
        <component v-if="!!data.icon"
                   :is="data.icon"
                   :type="data.id"
                   class="h-4 w-4 ml-2"
                   tooltip-position="bottom"
                   :show-label="false"
        />
        <div class="ml-2">{{ data.name }}</div>
      </div>
    </checkbox>
  </div>
</template>

<script>
import MessengerIconColored from '@/assets/images/channels/MessengerIconColored'
import WhatsappIconColored from '@/assets/images/channels/WhatsappIconColored'
import AmioChatIconColored from '@/assets/images/channels/AmioChatIconColored'
import ChartLegend from '@/components/analytics/charts/ChartLegend'
import Checkbox from '@/components/preview/Checkbox'

export default {
  name: 'CheckboxDropdownItem',
  components: {
    MessengerIconColored,
    WhatsappIconColored,
    AmioChatIconColored,
    Checkbox,
    ChartLegend
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    checkboxValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
      }
    }
  }
}
</script>

<style scoped>
.accent-primary-focus {
  accent-color: theme('colors.primary-focus');
}
</style>
